export default "__VITE_ASSET__36eeff01__"